<carousel *ngIf="activeSlideIndex != undefined" [interval]="myInterval" [(activeSlide)]="activeSlideIndex"
    [showIndicators]="showIndicator" [isAnimated]="false" [noPause]="true" (activeSlideChange)="onSlideChange($event)">
    <slide>
        <div class="d-flex overflow-auto">
            <div *ngFor="let doctorDetails of otList; let i = index" class="float-left background-black" [ngStyle]="otList.length < 4 ? calculateStyles(otList.length):''" [ngClass]="otList.length < 4 ? '':'desktop'">
                <div class="_wf-qm-colmain" id="doctorCard">
                    <div class="_wf-qm-col1">
                        <div class="_wf-qm-cardmain">
                            <div class="_wf-qm-topcard">
                                <div class="_wf-qm-profileimage" *ngIf="!doctorDetails.profile_id"><img class="imgsize"
                                        src="./assets/images/bedmanagement/extra-bed.svg"></div>
                                <div class="_wf-qm-profiledetail">
                                    <div class="text-block-284">{{doctorDetails.name}}</div>
                                    <div class="_wf-qm-dentistxt">
                                        <!-- <div class="text-block-285"><img class="speciality-icon"
                                            src="assets/images/icon-qualification-placeholder.png"></div> -->
                                        <div class="text-block-286">{{doctorDetails.partOfName}}</div>
                                    </div>
                                    <div class="text-block-287">{{doctorDetails.wing_name}}</div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div id="patientCard" *ngFor="let t of patientDetails; let p = index">
                    <div *ngIf="doctorDetails.name == t.currentRoom" class="_wf-qm-smallcard">
                        <div class="d-flex">
                            <div class="_wf-qm-shortform">
                                <div class="_wf-qm-namesf">
                                    <div class="text-block-288">{{t.patient_gender[0]}}</div>
                                </div>
                            </div>
                            <div class="d-flex align-items-center ml-3">
                                <!-- <div class="_wf-qm-uhidnumber">
                                <div class="text-block-289">{{t.patient_name}}</div>
                            </div> -->
                                <div class="_wf-qm-tck pr-1 ml-2">
                                    <div class="_wf-qm-circle">
                                        <div class="_wf-qm-ticnumber">
                                            <div class="text-block-290">{{t.uhId}}</div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="mt-1">
                            <div class="_wf-sdts-clearfirst-txt-clearbox _wf-sdts-cleartxtbox">
                                <div class="_wf-sdts-cleardocname">Age<br><span
                                        class="_wf-sdts-cleartimenum">{{t.patient_age}}</span></div>
                                <div class="_wf-sdts-cleardocname">Admission Date Time<br><span
                                        class="_wf-sdts-cleartimenum">{{t.admission_date_time | dateTimeFormat}}</span>
                                </div>
                                <div class="_wf-sdts-cleardocname">Surgery<br><span
                                        class="_wf-sdts-cleartimenum">{{t.serviceItemName?t.serviceItemName:'-'}}</span>
                                </div>
                                <div class="_wf-sdts-cleardocname">Surgeon<br><span
                                        class="_wf-sdts-cleartimenum">{{t.currentTreatingDoctor?baseService.decryptText(key,t.currentTreatingDoctor):'-'}}</span>
                                </div>
                                <div class="_wf-sdts-cleardocname">PreOp Transfer Date Time<br><span
                                        class="_wf-sdts-cleartimenum">{{t.ot_checkin_date_time?(t.ot_checkin_date_time |
                                        dateTimeFormat):'-'}}</span></div>
                                <div class="_wf-sdts-cleardocname">OT Check-In Date Time<br><span
                                        class="_wf-sdts-cleartimenum">{{t.ot_checkin_date_time?(t.ot_checkin_date_time |
                                        dateTimeFormat):'-'}}</span></div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>